export default "__VITE_ASSET__CNRpybcI__"